import type { SxProps, Theme } from '@mui/material'

export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: ({ spacing }) => spacing(0.25),
  },
  trigger: {
    '&[data-active="true"]': {
      background: (theme: Theme) => theme.palette.primary.relatedLight,
    },
  },
} satisfies Record<string, SxProps<Theme>>
